module.exports = __webpack_public_path__ + "img/frames short.20dd5e74.jpg";